import { Alert, type AlertColor, ClickAwayListener, Snackbar } from '@mui/material';
import type { FC } from 'react';

// MUI v6 bug: Snackbar passes ownerState to ClickAwayListener which doesn't accept it
const SafeClickAwayListener = ({ ownerState: _ownerState, ...props }: any) => <ClickAwayListener {...props} />;

interface BottomSnackBarProps {
  severity: AlertColor;
  text: string;
  showBar: boolean;
  setShowBar: () => void;
}

export const BottomSnackBar: FC<BottomSnackBarProps> = ({ severity, text, showBar, setShowBar }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={showBar}
      onClose={setShowBar}
      autoHideDuration={2500}
      slots={{ clickAwayListener: SafeClickAwayListener }}
    >
      <Alert severity={severity} sx={{ width: '100%' }}>
        {text}
      </Alert>
    </Snackbar>
  );
};
